/**
 * Guest routes: routes that do not need authentication
 * (login, welcome etc).
 *
 * Will me merged into the router's 'route' array
 */
// import { getI18nInstance } from '@/i18n';

import { getI18n } from '@/helpers/i18n';
import AboutView from '@/views/guest/AboutView.vue';
import LoginView from '@/views/guest/LoginView.vue';
import PlaygroundView from '@/views/guest/PlaygroundView.vue';

const routes = [
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      title: () => getI18n().t('about'),
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: () => getI18n().t('anmelden'),
    },
  },
  {
    path: '/playground',
    name: 'playground',
    component: PlaygroundView,
    meta: {
      title: () => getI18n().t('playground'),
    },
  },
];

export default routes;
